import XMLconvert from 'xml-js';
import axios from 'axios';
import moment from 'moment';
import 'moment/locale/da';
import DummyData from './dummy';

moment.locale('da');

export const isProduction = process.env.NODE_ENV !== 'development';

export const mergeData = ({ events, venues }) => {
  return (events || []).map(ev => {
    const venue = (venues || []).find(item => item.venueCode === ev.venueCode);
    if (!venue) {
      return { id: ev.eventId, ...ev };
    }
    return {
      id: ev.eventId,
      ...ev,
      ...venue,
    };
  });
};

export const remap = (key, val) => {
  if (
    [
      'eventId',
      'eventCode',
      'eventName',
      'eventDescription',
      'venueName',
      'venueId',
      'city',
      'minPrice',
      'maxPrice',
      'url',
      'image',
      'venueCity',
      'venueCode',
      'venueImageUrl',
      'venueName',
      'venuePageUrl',
    ].indexOf(key) > -1
  ) {
    return val;
  }
  if (['eventDateTime', 'onsaleStartDateTime', 'onsaleEndDateTime'].indexOf(key) > -1) {
    return val && val._cdata ? moment(val._cdata).toDate() : null;
  }
  if (['isCancelled', 'seatsAvailable', 'soldOut'].indexOf(key) > -1) {
    return val && (val._cdata === '1' || val._cdata === 'true');
  }
  if (['venueLatitude', 'venueLongitude'].indexOf(key) > -1) {
    console.log('TEST1', val);

    return val ? Number(val._cdata) : null;
  }
  return null;
};

export const prettify = obj => {
  if (obj._cdata) {
    return obj._cdata;
  }
  return Object.keys(obj).reduce((prev, key) => {
    const cur = remap(key, obj[key]);
    if (cur === null) {
      return { ...prev };
    }
    if (typeof cur === 'object' && cur !== null && !(cur instanceof Date)) {
      return { ...prev, [key]: prettify(cur) };
    }
    return {
      ...prev,
      [key]: cur,
    };
  }, {});
};

export const getDataFromPath = async (path, showDummyData = false) => {
  if (showDummyData) {
    const { venues, events } = DummyData;
    return mergeData({ venues, events });
  }

  try {
    const res = await axios({
      method: 'get',
      url: `${isProduction ? process.env.PUBLIC_URL : 'http://dixontest.dk/api-test/'}?p=${encodeURIComponent(path)}`,
      headers: { 'Access-Control-Allow-Origin': '*' },
      crossDomain: true,
    });

    const xml = res.data;
    const result = JSON.parse(XMLconvert.xml2json(xml, { compact: true, spaces: 2 }));
    // const dummyJson = JSON.parse(XMLconvert.xml2json(DummyXML, { trim: true, compact: true, spaces: 2 }));
    // console.log('DUMMY', dummyJson);

    // const dummyEvents = [];
    // const dummyVenues = [];
    // const dummyData = dummyJson.kml.Document.Placemark.forEach((item, index) => {
    //   const coordsArr = item.Point.coordinates._text.split(',');
    //   const venueCode = `VENUE-${index}`;
    //   const eventId = `event-${index}`;
    //   const city = 'Aarhus';
    //   dummyEvents.push({
    //     eventId,
    //     venueCode,
    //     city,
    //     name: item.name._text,
    //     eventDateTime: moment()
    //       .add(index + 2, 'd')
    //       .toDate(),
    //     soldOut: Math.floor(Math.random() * 2) === 1,
    //     url: '#',
    //     venueLatitude: coordsArr[0],
    //     venueLongitude: coordsArr[1],
    //     venueName: item.name._text,
    //     venueCity: city,
    //   });
    //   dummyVenues.push({
    //     venueLatitude: coordsArr[0],
    //     venueLongitude: coordsArr[1],
    //     venueCode,
    //     venueName: item.name._text,
    //     venueCity: city,
    //   });
    // });

    // console.log(JSON.stringify({ dummyEvents, dummyVenues }));

    const events = Array.isArray(result.mnxweb.events.event)
      ? result.mnxweb.events.event.map(item => prettify(item))
      : [prettify(result.mnxweb.events.event)];
    const venues = Array.isArray(result.mnxweb.venues.venue)
      ? result.mnxweb.venues.venue.map(item => prettify(item))
      : [prettify(result.mnxweb.venues.venue)];
    const uniqueEvents = [];
    events.forEach(ev => {
      if (
        !uniqueEvents.find(
          item => item.venueId === ev.venueId && moment(item.eventDateTime).isSame(ev.eventDateTime, 'day'),
        )
      ) {
        uniqueEvents.push(ev);
      }
    });

    return mergeData({ events: uniqueEvents, venues });
  } catch (err) {
    console.log('ERROR', err); // eslint-disable-line
    return [];
  }
};
